{
  "resourceType": "Bundle",
  "type": "searchset",
  "total": 4,
  "link": [
    {
      "relation": "self",
      "url": "https://appmarket.epic.com/interconnect-amcurprd-oauth/api/FHIR/R4/MedicationRequest?_count=1000&patient=enUzUbclL5CmKODptMHj-iw3"
    }
  ],
  "entry": [
    {
      "link": [
        {
          "relation": "self",
          "url": "https://appmarket.epic.com/interconnect-amcurprd-oauth/api/FHIR/R4/MedicationRequest/ePs0ttTGlEvTmjXNLMmvhsg3"
        }
      ],
      "fullUrl": "https://appmarket.epic.com/interconnect-amcurprd-oauth/api/FHIR/R4/MedicationRequest/ePs0ttTGlEvTmjXNLMmvhsg3",
      "resource": {
        "resourceType": "MedicationRequest",
        "id": "ePs0ttTGlEvTmjXNLMmvhsg3",
        "identifier": [
          {
            "use": "usual",
            "system": "urn:oid:1.2.840.114350.1.13.0.1.7.2.798268",
            "value": "795650"
          }
        ],
        "status": "completed",
        "intent": "order",
        "category": [
          {
            "coding": [
              {
                "system": "http://terminology.hl7.org/CodeSystem/medicationrequest-category",
                "code": "inpatient",
                "display": "Inpatient"
              }
            ],
            "text": "Inpatient"
          }
        ],
        "medicationReference": {
          "reference": "Medication/e8h2QLuf9R4UG31qMYcEj.s0KDKLkuZXngioDnhuThhu2GGRsU.DdKYSujDSVmnCI3",
          "display": "gentamicin IVPB 80 mg (premix)"
        },
        "subject": {
          "reference": "Patient/enUzUbclL5CmKODptMHj-iw3",
          "display": "Identity, Wensel A"
        },
        "encounter": {
          "reference": "Encounter/eIpFi3BHvN3qKISoVbCZE6A3",
          "identifier": {
            "use": "usual",
            "system": "urn:oid:1.2.840.114350.1.13.0.1.7.3.698084.8",
            "value": "2053"
          },
          "display": "Hospital Encounter"
        },
        "authoredOn": "2010-08-14T17:53:31Z",
        "requester": {
          "reference": "Practitioner/e8bM9BibcJ25SLe6lJi5i9Q3",
          "type": "Practitioner",
          "display": "Attending Physician Emergency, MD"
        },
        "recorder": {
          "reference": "Practitioner/e8bM9BibcJ25SLe6lJi5i9Q3",
          "type": "Practitioner",
          "display": "Attending Physician Emergency, MD"
        },
        "courseOfTherapyType": {
          "coding": [
            {
              "system": "http://terminology.hl7.org/CodeSystem/medicationrequest-course-of-therapy",
              "code": "acute",
              "display": "Short course (acute) therapy"
            }
          ],
          "text": "Short course (acute) therapy"
        },
        "dosageInstruction": [
          {
            "text": "80 mg, Intravenous, Every 8 hours, First dose on Sat 8/14/10 at 1300, For 1 day",
            "timing": {
              "repeat": {
                "boundsPeriod": {
                  "start": "2010-08-14T18:00:00Z",
                  "end": "2010-08-15T17:59:00Z"
                },
                "count": 3,
                "frequency": 1,
                "period": 8,
                "periodUnit": "h"
              },
              "code": { "text": "Every 8 hours" }
            },
            "asNeededBoolean": false,
            "route": {
              "coding": [
                {
                  "system": "http://snomed.info/sct",
                  "code": "418114005",
                  "display": "Intravenous central route (qualifier value)"
                },
                {
                  "system": "urn:oid:1.2.840.114350.1.13.0.1.7.4.798268.7025",
                  "code": "11",
                  "display": "Intravenous"
                }
              ],
              "text": "Intravenous"
            },
            "doseAndRate": [
              {
                "type": {
                  "coding": [
                    {
                      "system": "http://epic.com/CodeSystem/dose-rate-type",
                      "code": "calculated",
                      "display": "calculated"
                    }
                  ],
                  "text": "calculated"
                },
                "doseQuantity": {
                  "value": 80,
                  "unit": "mg",
                  "system": "http://unitsofmeasure.org",
                  "code": "mg"
                }
              },
              {
                "type": {
                  "coding": [
                    {
                      "system": "http://epic.com/CodeSystem/dose-rate-type",
                      "code": "admin-amount",
                      "display": "admin-amount"
                    }
                  ],
                  "text": "admin-amount"
                },
                "doseQuantity": {
                  "value": 100,
                  "unit": "mL",
                  "system": "http://unitsofmeasure.org",
                  "code": "mL"
                }
              },
              {
                "type": {
                  "coding": [
                    {
                      "system": "http://epic.com/CodeSystem/dose-rate-type",
                      "code": "ordered",
                      "display": "ordered"
                    }
                  ],
                  "text": "ordered"
                },
                "doseQuantity": {
                  "value": 80,
                  "unit": "mg",
                  "system": "http://unitsofmeasure.org",
                  "code": "mg"
                }
              }
            ]
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://appmarket.epic.com/interconnect-amcurprd-oauth/api/FHIR/R4/MedicationRequest/eeHP8nqeUh8Ah0td3Fu2gUQ3"
        }
      ],
      "fullUrl": "https://appmarket.epic.com/interconnect-amcurprd-oauth/api/FHIR/R4/MedicationRequest/eeHP8nqeUh8Ah0td3Fu2gUQ3",
      "resource": {
        "resourceType": "MedicationRequest",
        "id": "eeHP8nqeUh8Ah0td3Fu2gUQ3",
        "identifier": [
          {
            "use": "usual",
            "system": "urn:oid:1.2.840.114350.1.13.0.1.7.2.798268",
            "value": "795651"
          }
        ],
        "status": "completed",
        "intent": "order",
        "category": [
          {
            "coding": [
              {
                "system": "http://terminology.hl7.org/CodeSystem/medicationrequest-category",
                "code": "inpatient",
                "display": "Inpatient"
              }
            ],
            "text": "Inpatient"
          }
        ],
        "medicationReference": {
          "reference": "Medication/eLSmw4.Hohw6Y.tKyg5VnVWVvLacWgC3KbiczHeBt0ESst-Uin6cMNAflUagk47IB3",
          "display": "lactated Ringer's infusion"
        },
        "subject": {
          "reference": "Patient/enUzUbclL5CmKODptMHj-iw3",
          "display": "Identity, Wensel A"
        },
        "encounter": {
          "reference": "Encounter/eIpFi3BHvN3qKISoVbCZE6A3",
          "identifier": {
            "use": "usual",
            "system": "urn:oid:1.2.840.114350.1.13.0.1.7.3.698084.8",
            "value": "2053"
          },
          "display": "Hospital Encounter"
        },
        "authoredOn": "2010-08-17T21:05:55Z",
        "requester": {
          "reference": "Practitioner/e9s-IdXQOUVywHOVoisd6xQ3",
          "type": "Practitioner",
          "display": "Attending Physician Inpatient, MD"
        },
        "recorder": {
          "reference": "Practitioner/exfo6E4EXjWsnhA1OGVElgw3",
          "type": "Practitioner",
          "display": "User Epic"
        },
        "courseOfTherapyType": {
          "coding": [
            {
              "system": "http://terminology.hl7.org/CodeSystem/medicationrequest-course-of-therapy",
              "code": "acute",
              "display": "Short course (acute) therapy"
            }
          ],
          "text": "Short course (acute) therapy"
        },
        "dosageInstruction": [
          {
            "text": "75 mL/hr, Intravenous, Continuous, Starting Tue 8/17/10 at 1615, For 1 day",
            "timing": {
              "repeat": {
                "boundsPeriod": {
                  "start": "2010-08-17T21:03:08Z",
                  "end": "2010-08-18T21:02:08Z"
                }
              },
              "code": { "text": "Continuous" }
            },
            "asNeededBoolean": false,
            "route": {
              "coding": [
                {
                  "system": "http://snomed.info/sct",
                  "code": "418114005",
                  "display": "Intravenous central route (qualifier value)"
                },
                {
                  "system": "urn:oid:1.2.840.114350.1.13.0.1.7.4.798268.7025",
                  "code": "11",
                  "display": "Intravenous"
                }
              ],
              "text": "Intravenous"
            },
            "doseAndRate": [
              {
                "type": {
                  "coding": [
                    {
                      "system": "http://epic.com/CodeSystem/dose-rate-type",
                      "code": "calculated",
                      "display": "calculated"
                    }
                  ],
                  "text": "calculated"
                },
                "doseQuantity": {
                  "value": 75,
                  "unit": "mL/hr",
                  "system": "http://unitsofmeasure.org",
                  "code": "mL/h"
                }
              },
              {
                "type": {
                  "coding": [
                    {
                      "system": "http://epic.com/CodeSystem/dose-rate-type",
                      "code": "ordered",
                      "display": "ordered"
                    }
                  ],
                  "text": "ordered"
                },
                "doseQuantity": {
                  "value": 75,
                  "unit": "mL/hr",
                  "system": "http://unitsofmeasure.org",
                  "code": "mL/h"
                }
              }
            ]
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://appmarket.epic.com/interconnect-amcurprd-oauth/api/FHIR/R4/MedicationRequest/elDjF07EcBY9aD1IF0HXc.w3"
        }
      ],
      "fullUrl": "https://appmarket.epic.com/interconnect-amcurprd-oauth/api/FHIR/R4/MedicationRequest/elDjF07EcBY9aD1IF0HXc.w3",
      "resource": {
        "resourceType": "MedicationRequest",
        "id": "elDjF07EcBY9aD1IF0HXc.w3",
        "identifier": [
          {
            "use": "usual",
            "system": "urn:oid:1.2.840.114350.1.13.0.1.7.2.798268",
            "value": "795649"
          }
        ],
        "status": "completed",
        "intent": "order",
        "category": [
          {
            "coding": [
              {
                "system": "http://terminology.hl7.org/CodeSystem/medicationrequest-category",
                "code": "inpatient",
                "display": "Inpatient"
              }
            ],
            "text": "Inpatient"
          }
        ],
        "medicationReference": {
          "reference": "Medication/e2EZ-EIWL0MgLNKiu82bBi4U5EOMgzjQrYlPdxIT7Pxlji02w0YZqo.Le1lXbzRGy3",
          "display": "ampicillin IVPB 1 g  in 50 mL (Mini-Bag Plus)"
        },
        "subject": {
          "reference": "Patient/enUzUbclL5CmKODptMHj-iw3",
          "display": "Identity, Wensel A"
        },
        "encounter": {
          "reference": "Encounter/eIpFi3BHvN3qKISoVbCZE6A3",
          "identifier": {
            "use": "usual",
            "system": "urn:oid:1.2.840.114350.1.13.0.1.7.3.698084.8",
            "value": "2053"
          },
          "display": "Hospital Encounter"
        },
        "authoredOn": "2010-08-14T17:53:29Z",
        "requester": {
          "reference": "Practitioner/e8bM9BibcJ25SLe6lJi5i9Q3",
          "type": "Practitioner",
          "display": "Attending Physician Emergency, MD"
        },
        "recorder": {
          "reference": "Practitioner/e8bM9BibcJ25SLe6lJi5i9Q3",
          "type": "Practitioner",
          "display": "Attending Physician Emergency, MD"
        },
        "courseOfTherapyType": {
          "coding": [
            {
              "system": "http://terminology.hl7.org/CodeSystem/medicationrequest-course-of-therapy",
              "code": "acute",
              "display": "Short course (acute) therapy"
            }
          ],
          "text": "Short course (acute) therapy"
        },
        "dosageInstruction": [
          {
            "text": "1 g, Intravenous, for 30 Minutes, Every 8 hours, First dose on Sat 8/14/10 at 1300, For 1 day",
            "timing": {
              "repeat": {
                "boundsPeriod": {
                  "start": "2010-08-14T18:00:00Z",
                  "end": "2010-08-15T17:59:00Z"
                },
                "count": 3,
                "duration": 30,
                "durationMax": 60,
                "durationUnit": "min",
                "frequency": 1,
                "period": 8,
                "periodUnit": "h"
              },
              "code": { "text": "Every 8 hours" }
            },
            "asNeededBoolean": false,
            "route": {
              "coding": [
                {
                  "system": "http://snomed.info/sct",
                  "code": "418114005",
                  "display": "Intravenous central route (qualifier value)"
                },
                {
                  "system": "urn:oid:1.2.840.114350.1.13.0.1.7.4.798268.7025",
                  "code": "11",
                  "display": "Intravenous"
                }
              ],
              "text": "Intravenous"
            },
            "doseAndRate": [
              {
                "type": {
                  "coding": [
                    {
                      "system": "http://epic.com/CodeSystem/dose-rate-type",
                      "code": "calculated",
                      "display": "calculated"
                    }
                  ],
                  "text": "calculated"
                },
                "doseQuantity": {
                  "value": 1,
                  "unit": "g",
                  "system": "http://unitsofmeasure.org",
                  "code": "g"
                }
              },
              {
                "type": {
                  "coding": [
                    {
                      "system": "http://epic.com/CodeSystem/dose-rate-type",
                      "code": "admin-amount",
                      "display": "admin-amount"
                    }
                  ],
                  "text": "admin-amount"
                },
                "doseQuantity": {
                  "value": 1,
                  "unit": "g",
                  "system": "http://unitsofmeasure.org",
                  "code": "g"
                }
              },
              {
                "type": {
                  "coding": [
                    {
                      "system": "http://epic.com/CodeSystem/dose-rate-type",
                      "code": "ordered",
                      "display": "ordered"
                    }
                  ],
                  "text": "ordered"
                },
                "doseQuantity": {
                  "value": 1,
                  "unit": "g",
                  "system": "http://unitsofmeasure.org",
                  "code": "g"
                }
              }
            ]
          }
        ]
      },
      "search": { "mode": "match" }
    }
  ]
}
